import React, { Component } from 'react';
import 'react-calendar/dist/Calendar.css';
import './CreateEvent.css';
import CreateEventInput from './CreateEventInput/CreateEventInput';
import AutoPlaceCompleteApi from './AutoPlaceComplete';
import { motion } from 'framer-motion';
import { Link, withRouter, Redirect } from 'react-router-dom';
import { backdropTransition, transitionDuration } from '../../../../../Util/PageTransitions';
import CreateEventInputDropdown from './EventInputWithDropdown/EventInputWithDropdown';
import TextEditor from "../../../../../Util/TextEditor/TextEditor";
import moment from 'moment';
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config } from '../../../../../config';
import "react-datepicker/dist/react-datepicker.css";
import { messages } from "../../../../../messages";
import { stripHtml, RECURRING_TYPE } from '../../../../../Util/helper';
import arrowBack from "../../../../../assets/arrow-back.svg";
import CustomSelect from '../../../../../Util/CustomSelect/CustomSelect';
import plusIcon from "../../../../../assets/add-icon.svg";
import ReactDatePicker from 'react-datepicker';
import TimeKeeper from 'react-timekeeper';
import timeImg from '../../../../../assets/clock-icon.png';

class CreateEvent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			eventName: {
				value: '',
				error: true,
			},
			eventDescription: {
				value: '',
				error: true,
			},
			selectedDate: {
				value: '',
				error: true,
			},
			eventAddress: {
				value: '',
				error: true,
			},
			eventImage: '',

			priceType: '',
			eventStartTime: {
				value: '',
				error: true,
			},
			eventEndTime: {
				value: '',
				error: true,
			},
			groupInfo: '',
			individualInfo: '',
			groupArr: [{ value: '' }],
			individualArr: [{ value: '' }],
			selectedRecurringOption: '',
			minimumGroupSize: '',
			maximumGroupSize: '',
			groupSizeError: true,
			formErrors: {},
			id: null,
			redirectCalendar: false,
			img: '',
			autocompleteInput: React.createRef(),
			autocomplete: null,
			query: '',
			showStartTime: false,
			showEndTime: false,
		}

		this.handleDropdownChange = this.handleDropdownChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.onFileChange = this.onFileChange.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.handleDescription = this.handleDescription.bind(this);
		this.handleInputDropdown = this.handleInputDropdown.bind(this);
		this.handleAddGroup = this.handleAddGroup.bind(this);
		this.handleGroupChange = this.handleGroupChange.bind(this);
	}


	handleInput = (e) => {
		const { name, value } = e.target;
		let error = false;
		if (!value) {
			error = true;
		}
		this.setState({
			...this.state,
			[name]: {
				value,
				error
			}
		})
	}

	handleInputDropdown = (data) => {
		this.setState({
			eventPrice: data.target.value,
		})
	}

	onDateChange = (date) => {
		let err = false;
		if (!date) {
			err = true;
		}
		this.setState({
			selectedDate: {
				value: date,
				error: err,
			}
		});
	}

	handleDropdownChange = (field, value) => {
		this.setState({
			[field]: value,
		},
			() => {
				if (this.state.maximumGroupSize < this.state.minimumGroupSize) {
					this.setState({ groupSizeError: true })
				} else {
					this.setState({ groupSizeError: false })
				}
			}
		)
	}

	onFileChange = (e) => {
		if (e.target.type === 'file') {
			let file = e.target.files[0];
			if (file) {
				this.setState({
					eventImage: file,
					img: <img src={`${URL.createObjectURL(e.target.files[0])}`} width="179" height="140" alt='eventImage' />
				});
			}
		}
	}

	handleDescription = (data) => {
		let error = false;
		let val = stripHtml(data);
		if (!val) {
			error = true;
		}
		this.setState((prev) => ({
			...prev,
			eventDescription: {
				value: data,
				error: error,
			}
		}))
	}

	handleAddGroup() {
		const values = [...this.state.groupArr];
		values.push({ value: '' });
		this.setState({ groupArr: values });
	}

	handleRemoveGroup(i) {
		const values = [...this.state.groupArr];
		values.splice(i, 1);
		this.setState({ groupArr: [...values] });
	}

	handleAddIndividual() {
		const values = [...this.state.individualArr];
		values.push({ value: '' });
		this.setState({ individualArr: values });
	}

	handleRemoveIndividual(i) {
		const values = [...this.state.individualArr];
		values.splice(i, 1);
		this.setState({ individualArr: values });
	}

	handleGroupChange(index, event) {
		const values = [...this.state.groupArr];
		values[index].value = event.target.value;
		values[index].value = values[index].value?.trim();
		this.setState({ groupArr: values });
	}

	handleIndividualChange(index, event) {
		const values = [...this.state.individualArr];
		values[index].value = event.target.value;
		values[index].value = values[index].value?.trim();
		this.setState({ individualArr: values });
	}

	handleValidation() {
		const { eventName, eventDescription, eventAddress, eventStartTime, eventEndTime, selectedDate, minimumGroupSize, maximumGroupSize } = this.state;
		let formErrors = {};
		let formIsValid = true;

		if (!eventName?.value?.trim()) {
			formIsValid = false;
			eventName.error = true;
			formErrors["eventNameErr"] = messages && messages.empty_event_name;
		}

		if (eventDescription?.value === '') {
			formIsValid = false;
			eventDescription.error = true;
			formErrors["eventDescriptionErr"] = messages && messages.empty_event_description;
		}

		if (!selectedDate?.value) {
			formIsValid = false;
			formErrors['selectedDateErr'] = messages && messages.empty_event_date;
		}

		if (!eventAddress?.value?.trim()) {
			formIsValid = false;
			eventAddress.error = true;
			formErrors["eventAddressErr"] = messages && messages.empty_event_address;
		}

		if (eventStartTime?.value === '') {
			formIsValid = false;
			eventStartTime.error = true;
			formErrors['eventStartTimeErr'] = messages && messages.empty_event_start_time;
		}

		if (eventEndTime?.value === '') {
			formIsValid = false;
			eventEndTime.error = true;
			formErrors['eventEndTimeErr'] = messages && messages.empty_event_end_time;
		}


		if (maximumGroupSize < minimumGroupSize) {
			formIsValid = false;
			this.setState({ groupSizeError: true })
			formErrors['groupSizeErr'] = messages && messages.event_group_size_error;
		}
		this.setState({ formErrors: formErrors });
		return formIsValid;
	}

	componentDidMount() {
		if (this.props && this.props.history && this.props.history.location.id) {
			axiosApi.get(`${config.apiUrl}/events/${this.props.history.location.id}`)
				.then(response => {
					if (response) {
						this.setState({
							eventName: { value: response.data.data.name },
							eventStartTime: { value: moment(response.data.data.start_time, 'HH:mm').format('hh:mm a') },
							eventEndTime: { value: moment(response.data.data.end_time, 'HH:mm').format('hh:mm a') },
							eventDescription: { value: response.data.data.description },
							selectedRecurringOption: response.data.data.recurring_type,
							minimumGroupSize: response.data.data.minimum_group_size,
							maximumGroupSize: response.data.data.maximum_group_size,
							eventAddress: { value: response.data.data.address },
							eventPrice: response.data.data.price,
							priceType: response.data.data.price_type,
							selectedDate: { value: new Date(response.data.data.date) },
							groupArr: response.data.data.group_info ? JSON.parse(response.data.data.group_info) : this.state.groupArr,
							individualArr: response.data.data.individual_info ? JSON.parse(response.data.data.individual_info) : this.state.individualArr,
							img: (response.data.data.image) ? <img src={`${response.data.data.image_url}`} width="179" height="140" alt='eventImage' /> : '',
							eventImage: response.data.data.image,
						})
					}
				})
			this.setState({
				id: this.props.history.location.id,
			});
		}
		else if (this.props.location.state) {
			if (this.props.location.state.date) {
				this.setState({
					selectedDate: { value: this.props.location.state.date, }
				})
			}
		}
	}

	removeNull = (array) => {
		const val = array.filter(el => {
			return el.value;
		});
		return val;
	}

	handleSubmit(event) {
		event.preventDefault();
		let startTime = this.state.eventStartTime.value;
		let endTime = this.state.eventEndTime.value;

		if (this.handleValidation()) {
			const data = {
				name: this.state.eventName.value?.trim(),
				description: this.state.eventDescription.value?.trim(),
				price: this.state.eventPrice || '',
				price_type: this.state.priceType || '',
				address: this.state.eventAddress.value?.trim() || '',
				minimum_group_size: this.state.minimumGroupSize || '',
				maximum_group_size: this.state.maximumGroupSize || '',
				date: this.state.selectedDate.value ? moment(this.state.selectedDate.value).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
				image: this.state.eventImage || '',
				start_time: moment(startTime, "hh:mm A").format("HH:mm"),
				end_time: moment(endTime, "hh:mm A").format("HH:mm"),
				recurring_type: this.state.selectedRecurringOption === 'Bi-weekly' ? 'bi_weekly' : (this.state.selectedRecurringOption || ''),
				group_info: this.removeNull(this.state.groupArr) || '',
				individual_info: this.removeNull(this.state.individualArr) || '',
			}
			let formdata = new FormData();
			formdata.append('name', data.name);
			formdata.append('description', data.description);
			formdata.append('price', data.price);
			formdata.append('address', data.address);
			formdata.append('minimum_group_size', data.minimum_group_size);
			formdata.append('maximum_group_size', data.maximum_group_size);
			formdata.append('date', data.date);
			formdata.append('recurring_type', data.recurring_type);
			formdata.append('price_type', data.price_type);
			formdata.append('image', data.image);
			formdata.append('start_time', data.start_time);
			formdata.append('end_time', data.end_time);
			formdata.append('group_info', data.group_info[0]?.value ? JSON.stringify(data.group_info) : '');
			formdata.append('individual_info', data.individual_info[0]?.value ? JSON.stringify(data.individual_info) : '');
			if (this.state.id) {
				axiosApi.put(`${config.apiUrl}/events/${this.state.id}`, formdata)
					.then((response) => {
						if (response) {
							this.setState({ redirectCalendar: true });
						}
					});
			} else {
				axiosApi.post(`${config.apiUrl}/events/create`, formdata)
					.catch(error => console.error('Error:', error))
					.then((response) => {
						if (response) {
							this.setState({ redirectCalendar: true });
						}
					});
			}
		}
	}

	handlePriceType = (val) => {
		this.setState((prev) => ({
			...prev,
			priceType: val
		}))
	}

	getPlace = (place) => {
		if (place?.addressVal) {
			this.setState((prev) => ({
				...prev,
				eventAddress: {
					value: place?.addressVal,
				}
			}))
		} else {
			this.setState((prev) => ({
				...prev,
				eventAddress: {
					value: place,
				},
			}))
		}
	}

	addGroupInfoItem(e) {
		e.preventDefault();
	}
	addIndividualInfoItem(e) {
		e.preventDefault();
	}

	render() {
		const redirect = this.state.redirectCalendar;
		if (redirect) {
			return <Redirect to='/admin/events' />;
		}
		const { eventNameErr, eventDescriptionErr, eventAddressErr, eventPriceErr, eventStartTimeErr, eventEndTimeErr, selectedDateErr, groupSizeErr } = this.state.formErrors;
		return (
			<motion.div className='CreateEventPageWrapper content-wrapper users-wrapper' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
				<div className="top-blk">
					<div className="heading-wrapper">
						<Link to="/admin/events"><button className="primary-btn back-btn"><img src={arrowBack} alt='' /> Back to Events</button></Link>
						{this.state.id ?
							<h1 className='heading adminCreateEventHeaderText'>Edit Event</h1>
							:
							<h1 className='heading adminCreateEventHeaderText'>Create New Event</h1>
						}
					</div>
					<form className="formEvent" encType="multipart/form-data">
						<div className="input-field">
							<CreateEventInput
								required={true}
								key='event_name'
								id='eventName'
								label='Event Name'
								name='eventName'
								value={this.state.eventName.value}
								onChange={this.handleInput}
								wrapperClass='adminCreateEventInputFullWidth'
								placeholder="Enter Name"
							/>
							{(this.state.eventName.error) &&
								<div className="error" style={{ color: "red" }}>{eventNameErr}</div>
							}
						</div>
						<div className='createEventTextareaWrapper input-field'>
							<label className='createEventTextareaLabel' htmlFor='eventDescription'>Event Description <sup>*</sup></label>
							<TextEditor
								edit={this.state.id ? true : false}
								id={'eventDescription'}
								value={this.state.eventDescription.value}
								onChange={this.handleDescription}
								type="sport"
							/>
							{this.state.eventDescription.error &&
								<div className="error" style={{ color: "red" }}>{eventDescriptionErr}</div>
							}
						</div>
						<div className="priceInput-wrapper">
							<CreateEventInputDropdown
								key='event_price'
								id='eventPrice'
								label='Event Price'
								name='eventPrice'
								value={this.state.eventPrice}
								type={'number'}
								onChange={this.handleInputDropdown}
								wrapperClass='adminCreateEventInputFullWidth'
								onDropdownChange={this.handlePriceType}
								options={['Person', 'Group']}
								selectedOption={this.state.priceType}
								placeholder="Enter price"
							/>
							{eventPriceErr &&
								<div className="error" style={{ color: "red" }}>{eventPriceErr}</div>
							}
						</div>
						<div className='adminCreateEventCalendarWrapper'>
							<label className='adminCreateEventCalendarLabel' htmlFor='createEventCalendar'>Event Date <sup>*</sup></label>
							<div className='adminCreateEventCalendar' id='createEventCalendar'>
								<div className="input-field">
									<ReactDatePicker
										placeholderText={'MM/DD/YYYY'}
										minDate={new Date()}
										maxDate=''
										selected={this.state.selectedDate.value}
										onChange={this.onDateChange}
									/>

									{this.state.selectedDate.error &&
										<div className="error" style={{ color: "red" }}>{selectedDateErr}</div>
									}
								</div>
							</div>
						</div>
						<div className="input-field address-field">

							<label>Event Address <sup>*</sup></label>
							<AutoPlaceCompleteApi
								getAddress={this.getPlace}
								address={this.state.eventAddress.value}
							/>

							{this.state.eventAddress.error &&
								<div className="error" style={{ color: "red" }}>{eventAddressErr}</div>
							}
						</div>
						<div className="input-group event-group">
							<div className="input-field event-input date-field">
								<label>Event start time <sup>*</sup></label>
								{this.state.showStartTime &&
									<div className="timepicker-modal">
										<TimeKeeper
											time={this.state.eventStartTime.value ? this.state.eventStartTime.value : '12:00pm'}
											switchToMinuteOnHourSelect
											doneButton={(newTime) => (
												<div className="modal-footer">
													<button className='white-btn btn' type='button' onClick={() => this.setState((prev) => ({
														...prev,
														showStartTime: false,
													}))}>Close</button>
													<button className='primary-btn' type='button' onClick={() => this.setState((prev) => ({
														...prev,
														eventStartTime: {
															value: newTime.formatted12,
														},
														showStartTime: false,
													}))}>Done</button>
												</div>
											)}
										/>
									</div>
								}
								<div className="date-input">
									<input placeholder='Select start time' value={this.state.eventStartTime.value} onFocus={() => this.setState({ showStartTime: true })}></input>
									<div className="icon-blk" onClick={() => this.setState({ showStartTime: true })}>
										<img src={timeImg} alt="clock" />
									</div>
								</div>
								{this.state.eventStartTime.error &&
									<div className="error" style={{ color: "red" }}>{eventStartTimeErr}</div>
								}
							</div>
							<div className="input-field date-field">
								<label>Event end time <sup>*</sup></label>
								{this.state.showEndTime &&
									<div className="timepicker-modal">
										<TimeKeeper
											time={this.state.eventEndTime.value ? this.state.eventEndTime.value : '12:00pm'}
											switchToMinuteOnHourSelect
											doneButton={(newTime) => (
												<div className="modal-footer">
													<button className='btn white-btn' type='button' onClick={() => this.setState((prev) => ({
														...prev,
														showEndTime: false,
													}))}>Close</button>
													<button className='primary-btn' type='button' onClick={() => this.setState((prev) => ({
														...prev,
														eventEndTime: {
															value: newTime.formatted12,
														},
														showEndTime: false,
													}))}>Done</button>
												</div>
											)}
										/>
									</div>
								}
								<div className="date-input">
									<input placeholder='Select end time' value={this.state.eventEndTime.value} onFocus={() => this.setState({ showEndTime: true })}></input>
									<div className="icon-blk" onClick={() => this.setState({ showEndTime: true })}>
										<img src={timeImg} alt="clock" />
									</div>
								</div>

								{(this.state.eventEndTime.error) &&
									<div className="error" style={{ color: "red" }}>{eventEndTimeErr}</div>
								}
							</div>
						</div>
						<CustomSelect
							uniqueKey={'event_recurring_type'}
							data={[
								{
									id: 'never',
									title: 'Never'
								},
								{
									id: 'weekly',
									title: 'Weekly'
								},
								{
									id: 'bi_weekly',
									title: 'Bi-weekly'
								},
								{
									id: 'monthly',
									title: 'Monthly'
								},
								{
									id: 'yearly',
									title: 'Yearly'
								}
							]}
							placeholder={this.state.selectedRecurringOption ? RECURRING_TYPE[this.state.selectedRecurringOption] : 'Select option'}
							type={'text'}
							onSelect={(data) => data && this.handleDropdownChange('selectedRecurringOption', data.id)}
							selector="title"
							label={'Recurring Event'}
						/>
						<div className="input-group">
							<div className="input-field">
								<CustomSelect
									uniqueKey={'event_Min_group_size'}
									data={(function (arr) {
										return Array.isArray(arr) ? arr.map((ar, idx) => ({ id: idx + 1, title: ar })) : []
									})(['None', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15])}
									placeholder={this.state.minimumGroupSize ? this.state.minimumGroupSize : 'Select option'}
									type={'text'}
									onSelect={(data) => data && this.handleDropdownChange('minimumGroupSize', data.title)}
									selector="title"
									label={'Minimum Group Size'}
								/>
							</div>
							<div className="input-field">
								<CustomSelect
									uniqueKey={'event_Max_group_size'}
									data={(function (arr) {
										return Array.isArray(arr) ? arr.map((ar, idx) => ({ id: idx + 1, title: ar })) : []
									})(['None', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15])}
									placeholder={this.state.maximumGroupSize ? this.state.maximumGroupSize : 'Select option'}
									type={'text'}
									onSelect={(data) => data && this.handleDropdownChange('maximumGroupSize', data.title)}
									selector="title"
									label={'Maximum Group Size'}
								/>
								{this.state.groupSizeError &&
									<div className="error" style={{ color: "red" }}>{groupSizeErr}</div>
								}
							</div>
						</div>
						<div className="event-img">
							{!this.state.img ?
								<div className="input-field">
									<label className='createEventInputLabel'>Choose Event Image</label>
									<div className="img-input">
										<label id="eventImage">
											<div className="add-icon">
												<img src={plusIcon} alt="plus" />
											</div>
											<input className="plus-icon createEventImageInput" type='file' name='eventImage' onChange={this.onFileChange} />
										</label>
									</div>
								</div>
								:
								<div className="createEventImageInputWrapper input-field">
									<label className='createEventInputLabel' htmlFor='eventImage'>Choose Event Image</label>
									<div className="flex-blk recipients-field img-input">
										<div className='img-show'>
											<label htmlFor='img'>
												{this.state.img}
											</label>
										</div>
									</div>
									<div className='createEventImageInputButtonContainer'>
										<label for="img" className='createEventImageInputButton primary-btn'>
											<input id='img' type='file' className='createEventImageInput' onChange={this.onFileChange} accept="image/*" />
											<p className='createEventInputButtonText'>Change Image</p>
										</label>
										<button type='button' className='createEventImageInputButton remove-img primary-btn' onClick={(e) => this.setState({ img: '', eventImagePreview: null, eventImage: '' })}>Remove Image</button>
									</div>
								</div>
							}
						</div>
						<div className="groupInfo-wrapper">
							<div className='groupInfo-blk'>
								<h1 className='heading'>Required Group Information</h1>
							</div>

							<div className="input-blk">
								{this.state.groupArr && this.state.groupArr.map((group, index) => {
									return (
										<div className="input-wrapper" key={`group-input-${index}`}>
											<div className="input-field">
												<label>Group Info Item</label>																																																																															
												<input id={`grp-${index}`} type="text" placeholder="Enter group info item" value={group.value} onChange={(e) => this.handleGroupChange(index, e)} />
											</div>
											<div className="icon-blk">
												{this.state.groupArr.length - 1 === index &&
													<span onClick={() => this.handleAddGroup()} className="add">+</span>}
												{this.state.groupArr.length !== 1 &&
													<span onClick={() => this.handleRemoveGroup(index)} className="subtract">-</span>}
											</div>
										</div>
									)
								})
								}
							</div>

						</div>
						<div className="individualInfo-wrapper">
							<div className='individualInfo-blk'>
								<h1 className='heading'>Required Individual Information</h1>
							</div>
							<div className="input-blk">
								{this.state.individualArr && this.state.individualArr.map((individual, index) => {
									return (
										<div className="input-wrapper" key={`indv-input-${index + 1}`}>
											<div className="input-field">
												<label>Individual Info Item</label>
												<input type="text" key={`Individual-${index}`} placeholder="Enter individual info item" value={individual.value} onChange={(e) => this.handleIndividualChange(index, e)} />
											</div>
											<div className="icon-blk">
												{this.state.individualArr.length - 1 === index &&
													<span onClick={() => this.handleAddIndividual()} className="add">+</span>}
												{this.state.individualArr.length !== 1 &&
													<span onClick={() => this.handleRemoveIndividual(index)} className="subtract">-</span>}
											</div>
										</div>
									)
								})}
							</div>

						</div>
					</form>
				</div>
				<div className="footer-blk">
					<div className='createEventFooterContainer'>
						<button type='submit' onClick={this.handleSubmit} className='createEventFooterButton' >{this.state.id ? 'Save' : 'Create'} Event</button>
					</div>
				</div>
			</motion.div>
		)
	}
}
export default withRouter(CreateEvent);
